import { createListenerMiddleware } from "@reduxjs/toolkit";
import { setPermissionModal } from "./slices/ui.slice";

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: (action) =>
    action.type.endsWith("/rejected") &&
    String(action.payload).includes("Unauthorized"),
  effect: async (action, listenerApi) => {
    listenerApi.dispatch(setPermissionModal(true));
  },
});